var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-align-center"},[_c('rd-status',{staticClass:"ml-10",attrs:{"statusType":_vm.statusObj.status}}),_c('div',{staticClass:"font-h6-regular color-gy-8"},[_vm._v(_vm._s(_vm.statusObj.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }